import { m8API } from 'services/production/m8';
import { CalculateClientProductService } from 'types/services';
import { normalizeM8TariffParts } from '../utils/normalizeM8TariffParts';

export const calculateClientProduct: CalculateClientProductService = async (
  params
) => {
  const { formValues, m8ProductType } = params;

  const m8TariffParts = await m8API.admin.calculateTarifParts({
    priceCalculationComponentType: m8ProductType,
    comission: Number(formValues.partnerPercent),
    discount: Number(formValues.discountPercent),
  });

  const calculation = normalizeM8TariffParts(
    m8TariffParts
  ).toClientProductCalculation();

  return calculation;
};
